"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WHCM_SELECTED_ITEM_COLOR = exports.WHCM_LINK_COLOR = exports.WHCM_ITEM_COLOR = exports.WHCM_HIGHLIGHT_COLOR = exports.WHCM_DISABLED_ITEM_COLOR = exports.WHCM_BUTTON_COLOR = exports.WHCM_BACKGROUND_COLOR = exports.TOOLTIP_HORIZONTAL_SPACING = exports.TOOLTIP_COLOR = exports.SCREEN_EDGE_GAP = exports.MISSING_ALT_TEXT_TEST_FLAG = exports.MEDIA_WIDTH = exports.MEDIA_HEIGHT = exports.LABEL_WARNING_COLOR = exports.LABEL_VERTICAL_SPACING = exports.LABEL_SPACING = exports.LABEL_SIZE = exports.LABEL_ERROR_COLOR = exports.LABEL_COLOR = exports.LABEL_ASTERISK_SPACING = exports.LABEL_ASTERISK_COLOR = exports.EventKeys = exports.EventKeyCodes = exports.EM_TO_PX_RATIO = exports.DEFAULT_S_ICON_SIZE = exports.DEFAULT_SPACE_BETWEEN_ICON = exports.DEFAULT_LINE_HEIGHT = exports.DEFAULT_ICON_SIZE = exports.BORDER_SCALE = exports.A11Y_SIZE = exports.A11Y_MIN_SIZE_2_5_8 = exports.A11Y_MIN_SIZE = exports.A11Y_INLINE_MIN_SIZE = void 0;
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
const EventKeys = exports.EventKeys = {
  SPACEBAR: ' ',
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  BACKSPACE: 'Backspace',
  DELETE: 'Delete',
  PAGE_UP: 'PageUp',
  PAGE_DOWN: 'PageDown',
  TAB: 'Tab',
  SHIFT: 'Shift',
  HOME: 'Home',
  END: 'End',
  F10: 'F10'
};
const EventKeyCodes = exports.EventKeyCodes = {
  SPACEBAR: 32,
  ENTER: 13,
  ESCAPE: 27,
  ARROW_UP: 38,
  ARROW_DOWN: 40,
  ARROW_LEFT: 37,
  ARROW_RIGHT: 39,
  BACKSPACE: 8,
  DELETE: 46,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  TAB: 9,
  HOME: 36,
  END: 35,
  F10: 121,
  J: 74,
  K: 75,
  DIGITS: [48, 49, 50, 51, 52, 53, 54, 55, 56, 57],
  STR_DIGITS: ['Digit0', 'Digit1', 'Digit2', 'Digit3', 'Digit4', 'Digit5', 'Digit6', 'Digit7', 'Digit8', 'Digit9'],
  Q: 'KeyQ',
  W: 'KeyW',
  E: 'KeyE',
  R: 'KeyR',
  T: 'KeyT',
  Y: 'KeyY'
};
const EM_TO_PX_RATIO = exports.EM_TO_PX_RATIO = 16;
const BORDER_SCALE = exports.BORDER_SCALE = 1.3;

// Minimum accessible touch target sizes
const A11Y_SIZE = exports.A11Y_SIZE = 44;
const A11Y_MIN_SIZE = exports.A11Y_MIN_SIZE = 32;
const A11Y_MIN_SIZE_2_5_8 = exports.A11Y_MIN_SIZE_2_5_8 = 24; // WCAG22 SC 2.5.8
const A11Y_INLINE_MIN_SIZE = exports.A11Y_INLINE_MIN_SIZE = 24;

// Default sizes
const DEFAULT_LINE_HEIGHT = exports.DEFAULT_LINE_HEIGHT = 1;
const DEFAULT_ICON_SIZE = exports.DEFAULT_ICON_SIZE = 20;
const DEFAULT_S_ICON_SIZE = exports.DEFAULT_S_ICON_SIZE = 16;
const DEFAULT_SPACE_BETWEEN_ICON = exports.DEFAULT_SPACE_BETWEEN_ICON = 4;

// Constants for form elements
const LABEL_SIZE = exports.LABEL_SIZE = 'T200';
const LABEL_COLOR = exports.LABEL_COLOR = (0, _utils.token)('color.text.primary');
const LABEL_SPACING = exports.LABEL_SPACING = 'S200';
const LABEL_VERTICAL_SPACING = exports.LABEL_VERTICAL_SPACING = 'S200';
const LABEL_ASTERISK_SPACING = exports.LABEL_ASTERISK_SPACING = (0, _utils.token)('dimensions.spacing.50');
const LABEL_ASTERISK_COLOR = exports.LABEL_ASTERISK_COLOR = (0, _utils.token)('color.text.primary');
const LABEL_ERROR_COLOR = exports.LABEL_ERROR_COLOR = (0, _utils.token)('color.status.critical-icon');
const LABEL_WARNING_COLOR = exports.LABEL_WARNING_COLOR = (0, _utils.token)('color.status.warning-icon');
const TOOLTIP_COLOR = exports.TOOLTIP_COLOR = (0, _utils.token)('color.icon.secondary');
const TOOLTIP_HORIZONTAL_SPACING = exports.TOOLTIP_HORIZONTAL_SPACING = 'S100';

// A11y
const MISSING_ALT_TEXT_TEST_FLAG = exports.MISSING_ALT_TEXT_TEST_FLAG = 'accessibility-missing-alt-text';

// Must have 16:9 ratio due to video content
const MEDIA_WIDTH = exports.MEDIA_WIDTH = 544;
const MEDIA_HEIGHT = exports.MEDIA_HEIGHT = 306;

// Windows system color for highlighted items in WHCM
const WHCM_HIGHLIGHT_COLOR = exports.WHCM_HIGHLIGHT_COLOR = 'Highlight';
// Windows system color for buttons foreground in WHCM
const WHCM_BUTTON_COLOR = exports.WHCM_BUTTON_COLOR = 'ButtonText';
// Windows system color for links in WHCM
const WHCM_LINK_COLOR = exports.WHCM_LINK_COLOR = 'LinkText';
// Windows system color for backgrounds in WHCM
const WHCM_BACKGROUND_COLOR = exports.WHCM_BACKGROUND_COLOR = 'Canvas';
// Windows system color for disabled items in WHCM
const WHCM_DISABLED_ITEM_COLOR = exports.WHCM_DISABLED_ITEM_COLOR = 'GrayText';
// Windows system color for general items in WHCM
const WHCM_ITEM_COLOR = exports.WHCM_ITEM_COLOR = 'CanvasText';
// Windows system color for selected items in WHCM
const WHCM_SELECTED_ITEM_COLOR = exports.WHCM_SELECTED_ITEM_COLOR = 'SelectedItem';
const SCREEN_EDGE_GAP = exports.SCREEN_EDGE_GAP = 16;